<template>
  <div class="f-reward-type">
    <div class="contain">
      <div class="xl-title">奖励类型</div>
      <div class="sm-title">请选择要设置的奖励类型</div>
      <div class="type-list">
        <div class="type-item" @click="selectType(1)">
          <div class="icon" style="border-color: #376ef6;">
            <img
              src="../../../static/images/icon/icon-youhuiquan.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="info">
            <div class="xl-title">虚拟奖品</div>
            <div class="sm-title">一般是优惠券或奖券</div>
          </div>
          <van-icon name="arrow" />
        </div>
        <div class="type-item" @click="selectType(2)">
          <div class="icon" style="border-color: #55bb8b;">
            <img
              src="../../../static/images/icon/icon-fahuo.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="info">
            <div class="xl-title">实物奖品</div>
            <div class="sm-title">这类奖励需要收集发货地址发货</div>
          </div>
          <van-icon name="arrow" />
        </div>
        <div class="type-item" @click="selectType(3)">
          <div class="icon" style="border-color:  #ed7345;">
            <img
              src="../../../static/images/icon/icon-lianjie.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="info">
            <div class="xl-title">外部链接</div>
            <div class="sm-title">客户中奖后领奖直接跳转到外部链接</div>
          </div>
          <van-icon name="arrow" />
        </div>
        <div class="type-item" @click="selectType(4)">
          <div class="icon" style="border-color: #9355d5;">
            <img
              src="../../../static/images/icon/icon-hexiao.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="info">
            <div class="xl-title">到店核销</div>
            <div class="sm-title">领奖后生成一个券码，可凭密码扫码核销</div>
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: ["cc"],
  name: "f-reward-type",
  data() {
    return {};
  },
  methods: {
      selectType(type){
          this.cc.close(type);
      }
  },
  components: {},
  computed: {},
  created() {
    var t = this;
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "../../../static/scss/var";

.contain {
  padding: 20px;
  padding-top: 30px;
  .xl-title {
    font-size: 30px;
    color:$vm_fontcolor_main ;
  }
  .sm-title {
    color: $vm_fontcolor_minor2;
  }
  .type-list {
    padding: 20px 0;
    padding-bottom:0;
    margin-top: 10px;
    .type-item {
      @include flex;
      @include align_items_center;
      cursor: pointer;
        margin-bottom: 20px;
      .icon {
        margin-right: 10px;
        border: 1px solid #efefef;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        @include flex;
        @include align_items_center;
        @include justify_content_flex_center;
        
        img {
          width: 26px;
          height: 26px;
        }
      }
      .info {
        @include flex_1;
        .xl-title {
          font-size: 20px;
        }
        .sm-title {
          font-size: 14px;
        }
      }
    }
    .type-item:last-child{
        margin-bottom: 10px;
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
